interface DropCondition {
  minConfidenceLevel: number;
  minDays: number;
  minImpressions: number;
  minPerformanceLift: number;
  minResults: number;
}

interface RemoteCampaignOptimization {
  option: number;
  ongoingOptimization?: CampaignOptimizationData;
}

interface CampaignOptimization {
  optimizationOption: number;
  optimizationOptionName: string;
  optimizationData: CampaignOptimizationData;
}

interface CampaignOptimizationData {
  dropConditions: DropCondition[];
  entitiesToShowGoal: number;
  optimizeBy: number;
  optimizeGroup: number;
  postOptimizationServingCoefficient: number;
  attributionSignalIds?: number[];
  areAllAttributionSignalsSelected: boolean;
  conversionTypes: string[];
  areAllConversionTypesSelected: boolean;
}

enum OptimizationType {
  Creative = 'creative',
  Product = 'product',
  Output = 'output',
}

enum OptimizeBy {
  Conversions = 'Conversions',
  ClickThroughConversions = 'ClickThroughConversions',
}

enum OptimizeByValue {
  Clicks,
  Conversions = 10,
  ClickThroughConversions = 20,
  ExternalConversions = 30,
}

enum OptimizeByName {
  Clicks = 'Clicks',
  Conversions = 'Conversions',
  ClickThroughConversions = 'ClickThroughConversions',
  ExternalConversions = 'ExternalConversions',
}

enum OptimizeAcrossValue {
  Campaign = 0,
  Placement = 10,
  AdSet = 20,
}

enum OptimizeAcrossName {
  Campaign = 'Campaign',
  Placement = 'Placement',
  AdSet = 'AdSet',
}

interface ExternalConversionType {
  conversionType: string;
  totalConversionsForRecentDays: number;
  totalSalesForRecentDays: number;
}

export {
  OptimizationType,
  OptimizeBy,
  OptimizeByValue,
  OptimizeByName,
  DropCondition,
  CampaignOptimizationData,
  CampaignOptimization,
  RemoteCampaignOptimization,
  ExternalConversionType,
  OptimizeAcrossValue,
  OptimizeAcrossName,
};
